import React from 'react';

export declare type FocusType = 'false' | 'true';

export type IconProps = {
  className?: string;
  color?: string;
  focusable?: FocusType;
  height?: number;
  onClick?: () => void;
  size?: number;
  width?: number;
};

export const Instagram: React.FC<IconProps & JSX.IntrinsicElements['svg']> = ({
  className = '',
  color = '#090C33',
  focusable = 'false',
  height,
  onClick,
  size = 24,
  width,
  ...rest
}) => {
  const iconColor = undefined;

  return (
    <svg
      fill="none"
      height={height || size}
      width={width || size}
      onClick={onClick}
      className={className}
      focusable={focusable}
      {...rest}
      viewBox="0 0 24 24"
    >
      <path
        fill={iconColor || color}
        d="M3.035 8.566c.02-.874.12-1.737.47-2.552.64-1.488 1.77-2.393 3.334-2.769.953-.229 1.928-.225 2.898-.235 1.55-.014 3.1-.013 4.649.001.836.008 1.673.027 2.502.173 2.078.366 3.578 1.87 3.94 3.942.14.798.17 1.604.171 2.41.003 1.956-.009 3.913-.03 5.87-.009.88-.114 1.749-.462 2.569-.65 1.53-1.81 2.447-3.422 2.807-.905.203-1.83.208-2.75.213-1.71.008-3.418.007-5.127-.008-.806-.007-1.616-.029-2.404-.233-2.02-.525-3.217-1.828-3.624-3.864-.164-.82-.163-1.653-.176-2.484-.012-.806.006-4.7.031-5.84zm5.83-3.91a9.3 9.3 0 00-1.543.149c-1.169.224-1.992.886-2.393 2.028-.155.44-.229.897-.249 1.36-.1 2.355-.08 4.71-.023 7.065.011.475.052.957.145 1.422.259 1.296 1.032 2.132 2.32 2.475.544.145 1.101.186 1.659.188 2.147.008 4.294.012 6.442-.003.49-.004.988-.052 1.468-.147 1.214-.237 2.054-.937 2.414-2.136a5.3 5.3 0 00.215-1.26c.11-2.354.089-4.709.027-7.063a8.275 8.275 0 00-.177-1.553c-.235-1.07-.872-1.825-1.909-2.218a4.544 4.544 0 00-1.49-.28l-6.905-.027z"
      />
      <path
        fill={iconColor || color}
        d="M16.628 11.998c.002 2.544-2.062 4.611-4.617 4.623-2.545.012-4.633-2.071-4.634-4.621a4.625 4.625 0 019.25-.002h.001zM15 12.003a2.987 2.987 0 00-2.997-3 2.987 2.987 0 00-2.998 2.984 2.988 2.988 0 002.99 3.007A2.988 2.988 0 0015 12.003zM16.819 8.273A1.073 1.073 0 0115.731 7.2a1.079 1.079 0 011.078-1.086 1.08 1.08 0 01.01 2.16z"
      />
    </svg>
  );
};
